import { cn } from "@cca/components";

type BonusPointProps = {
  points: number;
  className?: string;
};

export const BonusPoint: React.FC<BonusPointProps> = ({
  points,
  className,
}) => {
  const isPositive = points > 0;
  const isNegative = points < 0;

  return (
    <span
      className={cn(
        "rounded-full border px-1.5 text-sm font-semibold",
        {
          "border-green-900 text-green-900": isPositive,
          "border-red-600 text-red-600": isNegative,
        },
        className,
      )}
    >
      {isPositive ? "+" : null}
      {points}
    </span>
  );
};
